import * as types from '../../action-types';
import { getSyndicatorDeals as initialState } from "../../initialState";

const getSyndicatorDeals = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_SYNDICATOR_DEALS_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_SYNDICATOR_DEALS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_SYNDICATOR_DEALS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_SYNDICATOR_DEALS_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getSyndicatorDeals;
